import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UnknownAction } from "redux";
import { AppState } from "../../store/types";
import { updateGenericFilter } from "./actions";
import { HcpSpecificMessagingDispatch, HcpSpecificMessagingState } from "./types";

export const useHcpSpecificMessagingState = (): HcpSpecificMessagingState =>
  useSelector(({ hcpSpecificMessaging }: AppState) => {
    return hcpSpecificMessaging;
  });

export const useHcpSpecificMessagingDispatch = (): HcpSpecificMessagingDispatch => {
  const dispatch = useDispatch();
  // typescript-fsa Action<T> lacks the index signature required by Redux 5's UnknownAction;
  // as unknown as UnknownAction is an intentional compatibility shim — migrate to RTK createAction to remove it.
  return useMemo(
    (): HcpSpecificMessagingDispatch => ({
      updateGenericFilter: (genericFilter) => dispatch(updateGenericFilter(genericFilter) as unknown as UnknownAction),
    }),
    [dispatch],
  );
};
